"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLunchItemsForDay = void 0;
/**
 * Get lunch items for day and week given as parameters
 * @param list Lunch list
 * @param weekIndex index of week
 * @param day day from week
 * @param maxItems template max items, if template has restriction.
 */
const getLunchItemsForDay = (list, weekIndex, day, maxItems) => {
    var _a;
    const { weeks, products, groups } = list;
    const currentLunchDay = (_a = weeks === null || weeks === void 0 ? void 0 : weeks[weekIndex]) === null || _a === void 0 ? void 0 : _a.days[day];
    if (currentLunchDay) {
        const { lunchItems, changes } = currentLunchDay;
        return lunchItems.reduce((items, { productId: itemProductId, itemId }) => {
            var _a, _b;
            // template max items reached, don't push any more items
            if (items.length === maxItems) {
                return items;
            }
            const changedProductId = (_a = changes === null || changes === void 0 ? void 0 : changes[itemProductId]) === null || _a === void 0 ? void 0 : _a.productId;
            const isItemHidden = (_b = changes === null || changes === void 0 ? void 0 : changes[itemProductId]) === null || _b === void 0 ? void 0 : _b.isHidden;
            // item is hidden, skip
            if (isItemHidden) {
                return items;
            }
            const productId = changedProductId || itemProductId;
            const { name, specialDiet, groupId } = products[productId];
            const group = getGroupForItem(groups, groupId);
            items.push({
                itemId,
                productId,
                specialDiet,
                name,
                group
            });
            return items;
        }, []);
    }
    return undefined;
};
exports.getLunchItemsForDay = getLunchItemsForDay;
/**
 * Get group name and price from groups
 * @param groups
 * @param groupId
 */
const getGroupForItem = (groups, groupId) => {
    if (groupId && groups[groupId]) {
        const { name, price } = groups[groupId];
        return {
            name,
            price
        };
    }
    return undefined;
};
//# sourceMappingURL=lunchLists.js.map